<template>
  <modal size="xl" @close="$emit('close')">
    <div class="w-full">
      <p class="text-lg mb-2">The following keyboard shortcuts are available for your use:</p>
      <div class="w-full flex flex-wrap | keyboard-shorcuts">
        <div class="w-full flex text-sm uppercase text-grey-6 text-center py-1">
          <div class="w-1/3">&nbsp;</div>
          <div class="w-1/3 font-semibold">Windows</div>
          <div class="w-1/3 font-semibold">Mac</div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Bold</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Ctrl</kbd> +
            <kbd>B</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>⌘</kbd> +
            <kbd>B</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Italic</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Ctrl</kbd> +
            <kbd>I</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>⌘</kbd> +
            <kbd>I</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Underline</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Ctrl</kbd> +
            <kbd>U</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>⌘</kbd> +
            <kbd>U</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Strikethrough</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Ctrl</kbd> +
            <kbd>D</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>⌘</kbd> +
            <kbd>D</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Bullet List</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Shift</kbd> +
            <kbd>Ctrl</kbd> +
            <kbd>8</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Shift</kbd> +
            <kbd>Ctrl</kbd> +
            <kbd>8</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Numbered List</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Shift</kbd> +
            <kbd>Ctrl</kbd> +
            <kbd>9</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Shift</kbd> +
            <kbd>Ctrl</kbd> +
            <kbd>9</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Undo</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Ctrl</kbd> +
            <kbd>Z</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>⌘</kbd> +
            <kbd>Z</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Redo</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Shift</kbd> +
            <kbd>Ctrl</kbd> +
            <kbd>Z</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Shift</kbd> +
            <kbd>⌘</kbd> +
            <kbd>Z</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Copy</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Ctrl</kbd> +
            <kbd>C</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>⌘</kbd> +
            <kbd>C</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Cut</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Ctrl</kbd> +
            <kbd>X</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>⌘</kbd> +
            <kbd>X</kbd>
          </div>
        </div>

        <div class="w-full flex py-1 px-2">
          <div class="w-1/3 text-grey-8">Paste</div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>Ctrl</kbd> +
            <kbd>V</kbd>
          </div>
          <div class="w-1/3 text-grey-7 text-center text-sm">
            <kbd>⌘</kbd> +
            <kbd>V</kbd>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "RichTextShortcutsModal"
}
</script>

<style scoped lang="scss">
.keyboard-shorcuts {
  >div {
    @apply bg-grey-3;
  }
  >div:nth-child(even) {
    @apply bg-grey-2;
  }
  >div:first-child {
    @apply bg-grey-7 text-grey-0;
  }
}
</style>
